import httpClient from "../config/HttpClient";
import PageRequest from "../PageRequest";
import PageResponse from "../PageResponse";
import { ACCESS_LOG_URL } from "../routes";

export interface AccessLogView {
  userId: string;
  ipAddress: string;
  clientName: string;
  accessTime: string;
}

export interface AccessLogFilter {
  userId: string;
}


export class AccessLogModel {
  static async list(page: PageRequest, filter: AccessLogFilter): Promise<PageResponse<AccessLogView>> {
    const response = await httpClient.get<PageResponse<AccessLogView>>(ACCESS_LOG_URL, {
      params: { ...page, userId: filter.userId },
    });
    return response.data;
  }
}

export default AccessLogModel;
